import { render, staticRenderFns } from "./incidences_in_warehouse.vue?vue&type=template&id=266180a0"
import script from "./incidences_in_warehouse.vue?vue&type=script&lang=js"
export * from "./incidences_in_warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports